<template>
  <nav class="navbar">
      <v-toolbar dark v-if="fbStatus.devStatus" color="blue" height="30">Test Environment Enabled | {{fbStatus.target}}</v-toolbar>

      <v-toolbar fixed dark flat height="40" color="orange" v-if="user">
        <v-toolbar-title @click="$router.push({name: 'Home'})"  class="font-weight-regular hover">Omentum</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn text >



           </v-btn>


           <v-menu offset-y>
             <template v-slot:activator="{ on, attrs }">
               <v-btn
                 color=""
                 text
                 dark
                 v-bind="attrs"
                 v-on="on"
               >
                 {{usersName}}
                 <v-icon>
                   mdi-menu
                 </v-icon>
               </v-btn>
             </template>
             <v-list>
               <v-list-item>
                 <v-list-item-title class="hover" @click="$router.push({name: 'Account'})"><v-icon class="pr-1">mdi-account</v-icon>Manage Account</v-list-item-title>
               </v-list-item>
               <v-list-item v-if="$store.state.editors">
                 <v-list-item-title  class="hover" @click="$router.push({name: 'ManageContent'})"><v-icon class="pr-1">mdi-file-document-edit</v-icon>Manage Content</v-list-item-title>
               </v-list-item>
               <v-list-item v-if="$store.state.editors">
                 <v-list-item-title  class="hover" @click="$router.push({name: 'Admin'})"><v-icon class="pr-1">mdi-cog-outline</v-icon>Admin Tools</v-list-item-title>
               </v-list-item>
               <!-- <v-list-item >
                 <v-list-item-title  class="hover" ><v-icon class="pr-1">mdi-help</v-icon><a target="_blank" style="color: inherit; text-decoration: inherit;" href="mailto:help@omentum.app">Need Help</a></v-list-item-title>
               </v-list-item> -->
               <v-list-item>
                 <v-list-item-title class="hover grey--text" @click="logout()"><v-icon color="grey" class="pr-1">mdi-logout</v-icon>Logout </v-list-item-title>
               </v-list-item>
             </v-list>
           </v-menu>

        </v-toolbar-items>
      </v-toolbar>
      <v-toolbar fixed dark flat height="40" color="orange" v-if="!user">
        <v-toolbar-title @click="$router.push({name: 'Home'})"  class="font-weight-regular hover">Omentum</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text @click="$router.push({name: 'Login'})">Login</v-btn>
        <v-toolbar-items>

        </v-toolbar-items>
      </v-toolbar>
  </nav>
</template>

<script>
import firebase from 'firebase'
import FB from '@/fb.js'

export default {
  name: "Navbar",
  data() {
    return {
      user: null,
      fbStatus: FB
    }
  },
  computed: {
    usersName(){
      if (this.$store.state.userData != null) {
        return this.$store.state.userData.firstname
      }
      else {
        return "Settings"
      }
    }
  },

  methods: {
    logout() {
      firebase.auth().signOut().then(() => {
        this.$router.push({ name: "Login" })
        this.user = firebase.auth().currentUser
      })
    }
  },
  created(){
    firebase.auth().onAuthStateChanged((user) => {
      if(user){
        this.user = user
      }
    })
  },

}

</script>

<style>
.hover {
  cursor:pointer;
}

</style>
